
/**
 * Basic buttom component. Can pass in variant prop to specify button style.
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const Button = ({ children, onClick, variant = "primary", size = 'default', className = "", disabled = false }) => {
    const variantStyles = {
        primary: "bg-purple-700 hover:bg-purple-800 text-white",
        secondary: "bg-black hover:bg-gray-900 text-white",
        danger: "bg-red-600 hover:bg-red-700 text-white",
        success: "bg-emerald-500 hover:bg-emerald-600 text-white",
        caution: "bg-yellow-500 hover:bg-yellow-600 text-white",
        cancel: "bg-gray-500 hover:bg-gray-600 text-white",
        noBackground: "text-gray-900 hover:text-gray-950 hover:underline",
        border: "text-purple-900 hover:text-purple-950 hover:underline border-2 border-purple-800 px-3 py-1.5"
    };

    const sizes = {
        default: 'py-2 px-4',
        small: 'py-1 px-3 text-sm',
        border: 'px-3 py-1.5'
    }

    // Combine variant styles with any custom classes passed
    const styles = `${sizes[size]} ${variantStyles[variant]} font-bold rounded min-w-24 ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`;

    return (
        <button onClick={onClick} className={styles} disabled={disabled}>
            {children}
        </button>
    );
};
